export const ChangeEvent = {
    /**
     * <zh/> 数据变更
     *
     * <en/> Data changes
     */
    CHANGE: 'change',
};
export var ChangeType;
(function (ChangeType) {
    /**
     * <zh/> 节点添加
     *
     * <en/> Node added
     */
    ChangeType["NodeAdded"] = "NodeAdded";
    /**
     * <zh/> 节点更新
     *
     * <en/> Node updated
     */
    ChangeType["NodeUpdated"] = "NodeUpdated";
    /**
     * <zh/> 节点删除
     *
     * <en/> Node removed
     */
    ChangeType["NodeRemoved"] = "NodeRemoved";
    /**
     * <zh/> 边添加
     *
     * <en/> Edge added
     */
    ChangeType["EdgeAdded"] = "EdgeAdded";
    /**
     * <zh/> 边更新
     *
     * <en/> Edge updated
     */
    ChangeType["EdgeUpdated"] = "EdgeUpdated";
    /**
     * <zh/> 边删除
     *
     * <en/> Edge removed
     */
    ChangeType["EdgeRemoved"] = "EdgeRemoved";
    /**
     * <zh/> Combo添加
     *
     * <en/> Combo added
     */
    ChangeType["ComboAdded"] = "ComboAdded";
    /**
     * <zh/> Combo更新
     *
     * <en/> Combo updated
     */
    ChangeType["ComboUpdated"] = "ComboUpdated";
    /**
     * <zh/> Combo删除
     *
     * <en/> Combo removed
     */
    ChangeType["ComboRemoved"] = "ComboRemoved";
})(ChangeType || (ChangeType = {}));
//# sourceMappingURL=change.js.map